<template>
	<span v-if="data || $slots.default" v-show="data.name || $slots.default" class="c-state" :tag="tag" :style="compStyle" @click="$emit('click')">
		<i v-if="tag && data.icon" class="c-state-icon tf">{{data.icon}}</i>
		<span v-if="$slots.default"><slot></slot></span>
		<span v-else>{{data.name}}</span>
		<i v-if="angle" class="c-state-tri tf">&#xe736;</i>
	</span>
</template>

<script>
	import {mapState} from 'vuex'
	
	export default {
		name: 'cState',
		
		props: {
			dict: String,
			async: Boolean,
			value: [Number, String],
			color: {
				type: [Boolean, String],
				default: true
			},
			tag: Boolean,
			hollow: Boolean,
			angle: Boolean
		},
		
		data() {
			return {
				colorDict: {
					gray: '#999999',
					blue: '#0D6EFE',
					red: '#FF0000',
					green: '#00ACA9',
					yellow: '#FFAE00',
					orange: '#FF6900'
				}
			}
		},
		
		computed: {
			...mapState(['dictData', 'asyncDictData']),
			
			compDictData() {
				if (this.async) {
					return this.asyncDictData[this.dict];
				} else {
					return this.dictData[this.dict];
				}
			},
			
			data() {
				return this.compDictData ? this.compDictData[this.value] : {name: this.value};
			},

			compStyle() {
				let color = typeof this.color == 'string' ? this.color : this.colorDict[this.data.color] || this.data.color;
				return this.tag ? {
					'border-color': color,
					color: this.hollow ? color : '#fff',
					background: this.hollow ? '#fff' : color
				} : {
					color: this.color ? color : ''
				}
			}
		},
		
		created() {
			if (this.async && this.dict && !this.compDictData) {
				this.$store.dispatch('getAsyncDict', this.dict);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.c-state {
		display: inline-block;
		
		&[tag] {
			box-sizing: border-box;
			height: .4rem;
			border-width: .02rem;
			border-style: solid;
			padding: 0 .16rem;
			border-radius: .2rem;
			line-height: .36rem;
			font-size: .24rem;
		}

		&-icon {
			margin-right: .04rem;
		}

		&-tri {
			margin-left: .06rem;
			font-size: .8em;
		}
	}
</style>